import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import {
  AppBar,
  Avatar,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../assets/eCarehealth-White-logo.svg";
import Flex from "../../../../components/Flex";
import LogOutModal from "../../../../components/LogOutModal";
import Text from "../../../../components/Text";
import { NavDataType } from "../../../../constants/common";
import { PATIENT_PATHS } from "../../../../constants/paths";
import useDisclosure from "../../../../hooks/use-disclosure";
import { useGetPatientProfile } from "../../../../queries/use-get-patient-profile";
import { DEFAULT_USER_SRC, NAVBAR } from "../../../../utils/utils";
import { PATIENT_TABS } from "../patient-constant";
import PatientPortalNotification from "./PatientPortalNotification";
import PatientTabs from "./PatientPortalTabs";
import { getStoredRealm } from "@/utils/auth-storage";

const PatientNavBar = () => {
  const logOutDisclosure = useDisclosure();
  const location = useLocation();
  const navigate = useNavigate();
  const { data: patientProfile } = useGetPatientProfile(getStoredRealm());
  const patientInfo = patientProfile?.data as
    { avatar?: string; firstName?: string; lastName?: string } | undefined;
  const currentTab = useMemo(() => {
    const rootActiveTabFromURL = location.pathname?.split("/")?.[3] || "";

    const activeTab = PATIENT_TABS.find(
      (tab) => tab.path && rootActiveTabFromURL === tab.value
    );

    return activeTab || PATIENT_TABS[0];
  }, [location.pathname]);

  const onTabChange = (_tab: string, ind: number) => {
    navigate(PATIENT_TABS[ind ?? 0].path!);
  };

  return (
    <AppBar
      sx={{
        zIndex: 90,
        height: "40px",
        boxShadow: "none !important",
      }}
      position="sticky"
    >
      <LogOutModal disclosureHost={logOutDisclosure} />

      <Flex
        alignItems={"center"}
        justifyContent={"space-between"}
        position={"relative"}
        px={"26px"}
        height={"100%"}
      >
        <Flex gap={1} width={"100%"} alignItems={"center"}>
          <img
            src={logo}
            alt="Company-Logo"
            width={NAVBAR.LOGO_WIDTH}
            height={NAVBAR.LOGO_HEIGHT}
          />
          {/* tabs */}
          <PatientTabs
            tabs={PATIENT_TABS}
            activeTab={currentTab.value}
            onTabChange={onTabChange}
          />
        </Flex>

        <Flex gap={1}>
          <IconButton style={{ color: "#fff" }}>
            <ChatOutlinedIcon />
          </IconButton>
          <PatientPortalNotification />
          <PopupState variant="popover" popupId="demo-popup-menu">
            {(popupState) => (
              <React.Fragment>
                <Flex
                  textAlign={"center"}
                  alignItems={"center"}
                  style={{ cursor: "pointer" }}
                  {...bindTrigger(popupState)}
                >
                  <Avatar
                    alt="admin image"
                    src={patientInfo?.avatar ?? DEFAULT_USER_SRC}
                    sx={{ width: 24, height: 24 }}
                  />
                </Flex>
                <Menu {...bindMenu(popupState)}>
                  <Flex
                    boxSizing={"border-box"}
                    width={"270px"}
                    flexDirection={"column"}
                  >
                    <Flex
                      alignItems={"center"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                      gap={1.2}
                      py={2}
                    >
                      <Avatar
                        alt="admin image"
                        src={patientInfo?.avatar ?? DEFAULT_USER_SRC}
                        sx={{
                          width: "80px",
                          height: "80px",
                        }}
                      />
                      <Text fontWeight={"bold"} variant="h4">
                        {`${patientInfo?.firstName ?? ""} ${patientInfo?.lastName ?? ""}`}
                      </Text>
                    </Flex>
                    <Divider />
                    <ProfileActions
                      popupState={popupState}
                      handleProfileClick={(it) => {
                        if (it.value === "log_out") logOutDisclosure.open();
                        else if (it.value === "profile")
                          navigate(it.path ?? "");
                      }}
                    />
                  </Flex>
                </Menu>
              </React.Fragment>
            )}
          </PopupState>
        </Flex>
      </Flex>
    </AppBar>
  );
};

export default PatientNavBar;

interface ProfileActionsProps {
  popupState?: any;
  handleProfileClick: (it: NavDataType) => void;
}

const ProfileActions = ({
  popupState,
  handleProfileClick,
}: ProfileActionsProps) => {
  return (
    <Flex flexDirection={"column"} py={1} boxSizing={"border-box"}>
      {PROFILE_OPTIONS.map((item) => {
        return (
          <MenuItem
            sx={{ py: 1.2, px: 2.5 }}
            onClick={() => {
              popupState.close();
              handleProfileClick(item);
            }}
            key={item.value}
          >
            {item?.icon && (
              <ListItemIcon>
                <item.icon fontSize="small" />
              </ListItemIcon>
            )}
            <Typography>{item.label}</Typography>
          </MenuItem>
        );
      })}
    </Flex>
  );
};

const PROFILE_OPTIONS: NavDataType[] = [
  // {
  //   label: "Help",
  //   // path: appPaths.help,
  //   value: "help",
  //   icon: HelpOutlineOutlinedIcon,
  // },
  {
    label: "Profile",
    path: PATIENT_PATHS.SETTINGS,
    value: "profile",
    icon: PersonOutlineOutlinedIcon,
  },
  {
    label: "Sign Out",
    value: "log_out",
    icon: LogoutIcon,
  },
];
